
import * as R from 'ramda';

export default function EditUserCustomerAssignmentsDialogController(
  $scope,
  $rootScope,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  orgDataService,
) {
  const vm = this;

  vm.filter = {};
  vm.filter.filterText = '';
  vm.filter.doesNotHaveAnyServices = false;
  vm.filter.hasComplianceServices = false;

  vm.handleSubmit = handleSubmit;
  vm.handleCloseDialog = handleCloseDialog;

  vm.handleFilterCustomers = handleFilterCustomers;
  vm.handleFilterTextChange = handleFilterTextChange;

  vm.handleSelectAll = handleSelectAll;
  vm.handleDeselectAll = handleDeselectAll;

  _activate();

  /** *************************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleDeselectAll() {
    R.forEach((cust) => {
      if (cust.customerId !== vm.user.customerId) {
        cust.isSelected = false;
      }
    }, vm.customers);
  }

  function handleSelectAll() {
    R.forEach((cust) => {
      cust.isSelected = true;
    }, vm.customers);
  }

  function handleSubmit() {
    loaderService.showViewLoader = true;
    const customerIds = _getFormSelections();
    return orgDataService.saveUserCustomerAssignments(vm.user.userId, customerIds).then(() => {
      alerts.success('The Customer Assignments has been saved successfully.');
      _closeDialog();
    })
      .catch(() => {
        alerts.error('An error occurred while saving the Customer Assignments.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function handleFilterCustomers() {
    if (vm.filter.hasComplianceServices) {
      vm.filter.hasAnyServices = true;
    }

    filterCustomers();
  }

  function handleFilterTextChange(searchString) {
    vm.filter.filterText = searchString;
    filterCustomers();
  }

  function filterCustomers() {
    vm.customers = $filter('filter')(vm.userCustomers, { displayName: vm.filter.filterText });

    if (vm.filter.doesNotHaveAnyServices) {
      vm.customers = $filter('filter')(vm.customers, { hasAnyService: false });
    }

    if (vm.filter.hasComplianceServices) {
      vm.customers = $filter('filter')(vm.customers, { hasComplianceServices: true });
    }

    vm.allCustomersFiltered = vm.customers.length === 0;
  }

  /** *************************************************
   * Private Functions
   */

  function _activate() {
    vm.customers = vm.userCustomers || null;
    vm.allCustomersFiltered = false;
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.admin.editUserCustomerAssignmentsDialog);
  }

  function _getFormSelections() {
    const customers = vm.userCustomers;
    const customerIds = getSelectedIds(customers, 'customerId');

    function getSelectedIds(idSource, idPropertyName) { // eslint-disable-line no-shadow
      const selectedIds = [];
      R.forEach((item) => {
        if (item.isSelected) {
          selectedIds.push(item[idPropertyName]);
        }
      }, idSource);
      return selectedIds;
    }

    return customerIds;
  }
}

EditUserCustomerAssignmentsDialogController.$inject = [
  '$scope',
  '$rootScope',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'orgDataService',
];
